import React from 'react';
import { Link } from 'react-router-dom';
import './Privacy.css';

function Privacy() {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <Link to="/" className="back-link">← Back to Home</Link>

        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: November 15, 2025</p>

        <section>
          <p>
            TriviaLOL, operated by OnePaceLLC ("we," "our," or "us"), is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard information when you use our mobile application (the "App").
          </p>
        </section>

        <section>
          <h2>1. Information We Collect</h2>

          <h3>1.1 Non-Personal Information</h3>
          <p>
            We do not collect personally identifiable information from our users. The App is designed to provide trivia gaming experiences without requiring personal data.
          </p>

          <h3>1.2 User-Generated Content (UGC)</h3>
          <p>
            If you choose to create and upload user-generated trivia content, we collect:
          </p>
          <ul>
            <li>Email address (required only for UGC submission)</li>
            <li>Trivia questions and answers you create</li>
            <li>Topic categories you select</li>
          </ul>
          <p>
            Email collection for UGC purposes is used solely to verify content creators and prevent abuse. We do not use your email for marketing purposes without your explicit consent.
          </p>

          <h3>1.3 Automatically Collected Information</h3>
          <p>
            When you use the App, we may automatically collect certain non-identifying information, including:
          </p>
          <ul>
            <li>Device type and operating system</li>
            <li>App usage statistics (games played, topics selected)</li>
            <li>Performance data and crash reports</li>
            <li>Approximate location (country/region level only, for leaderboard purposes)</li>
          </ul>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <p>We use the collected information to:</p>
          <ul>
            <li>Provide and maintain the App's functionality</li>
            <li>Enable 1v1 multiplayer trivia matches</li>
            <li>Moderate and review user-generated content</li>
            <li>Improve app performance and user experience</li>
            <li>Prevent fraud, abuse, and violations of our Terms of Service</li>
            <li>Display regional leaderboards and statistics</li>
            <li>Send important service announcements (not marketing)</li>
          </ul>
        </section>

        <section>
          <h2>3. Data Sharing and Disclosure</h2>
          <p>We do not sell, trade, or rent your information to third parties. We may share information only in the following circumstances:</p>
          <ul>
            <li><strong>Service Providers:</strong> We may share data with third-party services that help us operate the App (e.g., cloud hosting, analytics)</li>
            <li><strong>Legal Requirements:</strong> We may disclose information if required by law or to protect our rights and safety</li>
            <li><strong>Business Transfers:</strong> If TriviaLOL is acquired or merged, user data may be transferred to the new entity</li>
          </ul>
        </section>

        <section>
          <h2>4. Children's Privacy</h2>
          <p>
            TriviaLOL is intended for users aged 13 and above. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us, and we will delete such information.
          </p>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect the information we collect. However, no method of transmission over the internet or electronic storage is 100% secure. While we strive to protect your data, we cannot guarantee absolute security.
          </p>
        </section>

        <section>
          <h2>6. Third-Party Services</h2>
          <p>The App integrates with third-party services to help us improve user experience and analyze app performance. We are not responsible for the privacy practices of these third parties. We encourage you to review their privacy policies.</p>

          <h3>Amplitude Analytics</h3>
          <p>We use Amplitude Analytics to collect and analyze non-identifiable usage data about how users interact with the App. This helps us understand user behavior, improve features, and optimize the app experience. Amplitude collects:</p>
          <ul>
            <li>Device information (type, operating system, version)</li>
            <li>App usage patterns (features used, time spent, actions taken)</li>
            <li>Session data and event tracking</li>
          </ul>
          <p>
            All data collected by Amplitude is non-personally identifiable and aggregated. For more information about Amplitude's data practices, please visit <a href="https://amplitude.com/privacy" target="_blank" rel="noopener noreferrer">Amplitude's Privacy Policy</a>.
          </p>
        </section>

        <section>
          <h2>7. Your Rights and Choices</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access the information we have collected about you (if any)</li>
            <li>Request deletion of your data</li>
            <li>Opt-out of data collection by uninstalling the App</li>
            <li>Request that we stop using your email for UGC-related communications</li>
          </ul>
          <p>
            To exercise these rights, please contact us at the email address provided below.
          </p>
        </section>

        <section>
          <h2>8. International Users</h2>
          <p>
            TriviaLOL is available globally. If you access the App from outside the United States, please be aware that your information may be transferred to, stored, and processed in countries where our servers are located. By using the App, you consent to this transfer.
          </p>
        </section>

        <section>
          <h2>9. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the new Privacy Policy in the App and updating the "Last Updated" date. Your continued use of the App after changes are posted constitutes your acceptance of the updated policy.
          </p>
        </section>

        <section>
          <h2>10. Contact Us</h2>
          <p>
            If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:
          </p>
          <p>
            <strong>Company:</strong> OnePaceLLC<br />
            <strong>Email:</strong> onepaceapps@gmail.com<br />
            <strong>App:</strong> TriviaLOL
          </p>
        </section>

        <section className="acknowledgment">
          <p>
            By using TriviaLOL, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.
          </p>
        </section>

        <div className="footer-links">
          <Link to="/">Home</Link>
          <Link to="/support">Support</Link>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
